<template>
  <div class="home-hero">
    <div class="home-hero__left">
      <sc-text tag="h1" :field="fields.heading" />
      <sc-text tag="p" :field="fields.intro" class="home-hero__intro" />
    </div>
    <div class="home-hero__right">
      <!-- Placeholder - Home Hero Right -->
      <sc-placeholder name="jss-home-hero-right" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Home-HeroLayout',
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss">
.c-site__main {
  .home-hero {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    @include padding-y(2rem);
    @include padding-x-thin;

    &__left {
      h1 {
        font-size: 3.6rem;
        line-height: 4.2rem;
        margin-bottom: 1rem;

        @include large-desktop-up {
          font-size: 5rem;
          line-height: 5.6rem;
          margin-bottom: 2rem;
        }
      }

      @include desktop-up {
        width: 40%;
        padding-right: 7rem;
        margin-top: -6.5rem;
      }
    }
    &__right {
      @include desktop-up {
        width: 60%;
      }
    }

    p.home-hero__intro {
      @include font-styles('Arial', 2.4rem, 200, normal, 3rem, 0, $dark-blue);
      margin-bottom: 2rem;
    }
  }
}
</style>
